import { render, staticRenderFns } from "./loaderProduct.vue?vue&type=template&id=1c7bbada&scoped=true&"
import script from "./loaderProduct.vue?vue&type=script&lang=js&"
export * from "./loaderProduct.vue?vue&type=script&lang=js&"
import style0 from "./loaderProduct.vue?vue&type=style&index=0&id=1c7bbada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7bbada",
  null
  
)

export default component.exports